export default __webpack_public_path__ + "static/media/watches6.4d6a46fa.jfif";